import { FaSolidGraduationCap } from "solid-icons/fa";
import { RiUserFacesUserStarLine } from "solid-icons/ri";
import { type Component, Show } from "solid-js";

/** Skill = graduation cap (Font Awesome); persona = user-star line (Remix). */
export const SkillCategoryIcon: Component<{
  category?: "skill" | "persona";
  class?: string;
  "data-active"?: boolean;
}> = (props) => {
  const cls = () => props.class ?? "size-4";
  return (
    <Show
      when={props.category === "persona"}
      fallback={<FaSolidGraduationCap class={cls()} data-active={props["data-active"]} />}
    >
      <RiUserFacesUserStarLine class={cls()} data-active={props["data-active"]} />
    </Show>
  );
};
